import {createHelpers} from 'vuex-map-fields';
import Account from '../../api/account';

/* eslint-disable no-shadow */

// initial state
const state = {
  account: {
    subscription: {},
    creditCard: {}
  },
  accountUsers: [],
  accountUsersTotal: 0,
  dirty: 0
};

// Because by default, getters and mutations in Vuex
// modules, are globally accessible and not namespaced,
// you most likely want to rename the getter and mutation
// helpers because otherwise you can't reuse them in multiple,
// non namespaced modules.
const {getAccountField, mutateAccountField} = createHelpers({
  getterType: 'getAccountField',
  mutationType: 'mutateAccountField'
});

// getters - all receive state as first argument
const getters = {
  isAccountDirty: (state) => state.dirty,
  getAccount: (state) => state.account,
  getAccountUsers: (state) => state.accountUsers,
  getAccountUsersTotal: (state) => state.accountUsersTotal,
  getGitMode: (state) => !!state.account.gitMode,
  getAccountField
};

// actions
const actions = {
  async getAccount({commit}, user) {
    const account = await Account.get(user.account._id);
    commit('setAccount', account);
  },
  async getAccountUsers({commit}) {
    const {list, total} = await Account.getUsers(state.account._id);
    commit('setAccountUsers', list);
    commit('setAccountUsersTotal', total);
  },
  async updateAccount({commit}) {
    commit('setAccount', await Account.update(state.account._id, state.account));
  },
  async removeUserFromAccount({commit}, {accountId, userId}) {
    commit('removeAccountUser', await Account.removeUserFromAccount(accountId, userId));
    commit('decrementAccountUsersTotal');
  }
};

// mutations
const mutations = {
  clearAccountDirty(state) {
    state.dirty = 0;
  },
  setAccount(state, account) {
    state.account = account;
  },
  setAccountUsers(state, users) {
    state.accountUsers = users;
  },
  removeAccountUser(state, user) {
    for (let i = 0; i < state.accountUsers.length; ++i) {
      if (state.accountUsers[i]._id === user._id) {
        // https://vuejs.org/2016/02/06/common-gotchas/
        state.accountUsers.splice(i, 1);
      }
    }
  },
  decrementAccountUsersTotal(state) {
    state.accountUsersTotal--;
  },
  setAccountUsersTotal(state, total) {
    state.accountUsersTotal = total;
  },
  updateAccountField(state, field) {
    state.dirty++;
    mutateAccountField(state, field);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
